import { useState } from 'react';
import emailjs from '@emailjs/browser';
import "../styles/contactFrom.css";

const ContactForm = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [stateMessage, setStateMessage] = useState(null);
  const sendEmail = (e) => {
    e.persist();
    e.preventDefault();
    setIsSubmitting(true);
    emailjs
      .sendForm(
        "service_3bllvvt",
        "template_rrkeg0a",
        e.target,
        "fP07MZBmLPOt9kKTK"
      )
      .then(
        (result) => {
          setStateMessage('Message sent!');
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        },
        (error) => {
          setStateMessage('Something went wrong, please try again later');
          setIsSubmitting(false);
          setTimeout(() => {
            setStateMessage(null);
          }, 5000); // hide message after 5 seconds
        }
      );
    
    // Clears the form after sending the email
    e.target.reset();
  };
  return (
    <form onSubmit={sendEmail} className="contactFrom">
      <label>Name</label>
      <input type="text" name="user_name" id="name"/>
      <br></br>
      <label>Email</label>
      <input type="email" name="user_email" id="email"/>
      <br></br>
      <label>Message</label>
      <textarea name="message" id="message"/>
      <br></br>
      <input type="submit" value="Send" id="sendButton" disabled={isSubmitting} />
      {stateMessage && <p>{stateMessage}</p>}
    </form>
  );
};
export default ContactForm;
